// src/utils/errorTracking.js
// Global JS error capture — catches uncaught exceptions and unhandled Promise rejections.
// Logs to console.error (visible in DevTools / Play Console adb logcat) and to the
// Firestore "errorLogs" collection so errors are inspectable after the fact.
//
// A 5-second debounce prevents cascading errors from spamming Firestore writes.
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../firebase';

let lastLoggedAt = 0;
const DEBOUNCE_MS = 5000;

const logToFirestore = async (payload) => {
  const now = Date.now();
  if (now - lastLoggedAt < DEBOUNCE_MS) return;
  lastLoggedAt = now;
  try {
    await addDoc(collection(db, 'errorLogs'), {
      ...payload,
      userId:    auth.currentUser?.uid || null,
      url:       window.location.href,
      userAgent: navigator.userAgent,
      timestamp: serverTimestamp(),
    });
  } catch {
    // Swallow — logging must never cause further errors
  }
};

export const initErrorTracking = () => {
  window.addEventListener('error', (event) => {
    const message = event.message || 'Unknown error';
    const stack   = event.error?.stack || '';
    console.error('[WasteGame] Uncaught error:', message, stack);
    logToFirestore({ type: 'uncaught_error', message, stack });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message || String(event.reason) || 'Unhandled rejection';
    const stack   = event.reason?.stack   || '';
    console.error('[WasteGame] Unhandled rejection:', message, stack);
    logToFirestore({ type: 'unhandled_rejection', message, stack });
  });
};
